import type { GameId } from './api/runs.js';

export type MinigameHub = 'phone' | 'console' | 'world';

export type MinigameDef = {
  id: GameId;
  namePl: string;
  hubs: MinigameHub[];
  worldEntry?: string; // scene key
  goodStarsThreshold: number;
  minDurationMs: number;
  maxStars: number;
};

/**
 * minDurationMs — próg dziecięco-realny (WAVE3-G5).
 * Za krótka runda nie jest odrzucana: serwer clampuje nagrodę do bazy
 * (5-latek kończy memory w ~10 s ≠ oszustwo).
 */
export const MINIGAMES: Record<GameId, MinigameDef> = {
  rhythm: {
    id: 'rhythm',
    namePl: 'Bau-Bau Rytm',
    hubs: ['phone', 'console'],
    goodStarsThreshold: 10,
    minDurationMs: 5_000,
    maxStars: 20,
  },
  cooking: {
    id: 'cooking',
    namePl: 'Kuchnia Kości',
    hubs: ['phone', 'world'],
    worldEntry: 'Cafe',
    goodStarsThreshold: 6,
    minDurationMs: 6_000,
    maxStars: 12,
  },
  runner: {
    id: 'runner',
    namePl: 'Wyścig Piesków',
    hubs: ['phone', 'console'],
    goodStarsThreshold: 8,
    minDurationMs: 10_000,
    maxStars: 16,
  },
  bubbles: {
    id: 'bubbles',
    namePl: 'Bąbelki',
    hubs: ['phone', 'console', 'world'],
    worldEntry: 'School',
    goodStarsThreshold: 12,
    minDurationMs: 10_000,
    maxStars: 30,
  },
  puzzle: {
    id: 'puzzle',
    namePl: 'Puzzle',
    hubs: ['console', 'world'],
    worldEntry: 'School',
    goodStarsThreshold: 1,
    minDurationMs: 6_000,
    maxStars: 1,
  },
  swimrace: {
    id: 'swimrace',
    namePl: 'Wyścig pływacki',
    hubs: ['world'],
    worldEntry: 'Pool',
    goodStarsThreshold: 2,
    minDurationMs: 4_000,
    maxStars: 5,
  },
};

export function gamesForHub(hub: MinigameHub): MinigameDef[] {
  return Object.values(MINIGAMES).filter((g) => g.hubs.includes(hub));
}
